import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';
import { API, graphqlOperation } from 'aws-amplify';
// ---------------------------- GraphQL Query --------------------------------------------------

const getTree = async (bucket, father, parent) => (await API.graphql(graphqlOperation(queries.getTree, {
    bucket,
    father,
    parent
})));

const searchFile = async (bucket, search) => (await API.graphql(graphqlOperation(queries.searchFile, {
    bucket,
    search
})));

const getLinkedFile = async (father, parent) => (await API.graphql(graphqlOperation(queries.getLinkedFile, {
    father,
    parent
})));

const getNotLinkedFile = async (father, parent) => (await API.graphql(graphqlOperation(queries.getNotLinkedFile, {
    father,
    parent
})));

const getFolderListOperator = async () => (await API.graphql(graphqlOperation(queries.getFolderListOperator)));

const getUsers = async (role, provider) => (await API.graphql(graphqlOperation(queries.getUsers, {
    role,
    provider
})));

const getOrganizations = async () => (await API.graphql(graphqlOperation(queries.getOrganizations)));

const getCustomerGroups = async () => (await API.graphql(graphqlOperation(queries.getCustomerGroups)));

const getFile = async (father, bucket) => (await API.graphql(graphqlOperation(queries.getFile, {
    father,
    bucket
})));

const getLinkedUser = async (path) => (await API.graphql(graphqlOperation(queries.getLinkedUser, {
    path
})));

const getDashboardAdmin = async () => (await API.graphql(graphqlOperation(queries.getDashboardAdmin)));

const getDashboardProvider = async () => (await API.graphql(graphqlOperation(queries.getDashboardProvider)));

const getDashboardCustomer = async () => (await API.graphql(graphqlOperation(queries.getDashboardCustomer)));


const getAdCustNotDowload = async () => (await API.graphql(graphqlOperation(queries.getAdCustNotDowload)));

const getAdCustNotConfirmed = async () => (await API.graphql(graphqlOperation(queries.getAdCustNotConfirmed)));

const getAdProvNotDowload = async () => (await API.graphql(graphqlOperation(queries.getAdProvNotDowload)));

const getProvNotDowload = async () => (await API.graphql(graphqlOperation(queries.getProvNotDowload)));

const getCustNotDowload = async () => (await API.graphql(graphqlOperation(queries.getCustNotDowload)));

const getCustNotConfirmed = async () => (await API.graphql(graphqlOperation(queries.getCustNotConfirmed)));

const getFilePath = async (father, bucket) => (await API.graphql(graphqlOperation(queries.getFilePath, {
    father,
    bucket
})));

const getDownloadList = async (file) => (await API.graphql(graphqlOperation(queries.getDownloadList, {
    file
})));

const getConfirmList = async (file) => (await API.graphql(graphqlOperation(queries.getConfirmList, {
    file
})));

const getMakeDeliverableList = async (LastKey) => (await API.graphql(graphqlOperation(queries.getMakeDeliverableList, {
    LastKey
})));

const getMe = async (role, provider) => (await API.graphql(graphqlOperation(queries.getMe, {
    role,
    provider
})));

// ---------------------------- GraphQL Mutations --------------------------------------------------

const putOrganization = async (name, description) => (await API.graphql(graphqlOperation(mutations.putOrganization, {
    name,
    description
})))

const putCustomerGroup = async (name, description) => (await API.graphql(graphqlOperation(mutations.putCustomerGroup, {
    name,
    description
})))

const putUser = async (company, email, name, phone, role, sftp, surname) => (await API.graphql(graphqlOperation(mutations.putUser, {
    company,
    email,
    name,
    phone,
    role,
    sftp,
    surname
})))

const linkFolder = async (username, path) => (await API.graphql(graphqlOperation(mutations.linkFolder, {
    username,
    path
})))

const removeLinkFolder = async (username, path) => (await API.graphql(graphqlOperation(mutations.removeLinkFolder, {
    username,
    path
})))

const deleteFolderProvider = async (path) => (await API.graphql(graphqlOperation(mutations.deleteFolderProvider, {
    path
})))

const deleteUser = async (username) => (await API.graphql(graphqlOperation(mutations.deleteUser, {
    username
})))

const deleteGroup = async (groupName) => (await API.graphql(graphqlOperation(mutations.deleteGroup, {
    groupName
})))

const disableUser = async (username) => (await API.graphql(graphqlOperation(mutations.disableUser, {
    username
})))

const enableUser = async (username) => (await API.graphql(graphqlOperation(mutations.enableUser, {
    username
})))

const resetPassword = async (username) => (await API.graphql(graphqlOperation(mutations.resetPassword, {
    username
})))

const lockFile = async (filePath) => (await API.graphql(graphqlOperation(mutations.lockFile, {
    filePath
})))

const unlockFile = async (filePath) => (await API.graphql(graphqlOperation(mutations.unlockFile, {
    filePath
})))

const confirmFile = async (filePath) => (await API.graphql(graphqlOperation(mutations.confirmFile, {
    filePath
})))

const makeDeliverableExchange = async (sourcePrefix, targetPrefix) => (await API.graphql(graphqlOperation(mutations.makeDeliverableExchange, {
    sourcePrefix,
    targetPrefix
})))

const makeDeliverableCustomer = async (sourcePrefix, targetPrefix, groupName) => (await API.graphql(graphqlOperation(mutations.makeDeliverableCustomer, {
    sourcePrefix,
    targetPrefix,
    groupName
})))


const putSftpCustomer = async (id,email, role, name, surname, phone, company) => (await API.graphql(graphqlOperation(mutations.putSftpCustomer, {
    id,
    email,
    role,
    name,
    surname,
    phone,
    company
})))

const deleteSftpCustomer = async (id, username) => (await API.graphql(graphqlOperation(mutations.deleteSftpCustomer, {
    id,
    username
})))

export {
    getTree,
    getLinkedFile,
    getNotLinkedFile,
    getOrganizations,
    putOrganization,
    getUsers,
    getDashboardAdmin,
    getDashboardProvider,
    getDashboardCustomer,
    putUser,
    getFolderListOperator,
    linkFolder,
    removeLinkFolder,
    getFile,
    deleteFolderProvider,
    deleteUser,
    deleteGroup,
    disableUser,
    enableUser,
    resetPassword,
    getLinkedUser,
    getCustomerGroups,
    putCustomerGroup,
    lockFile,
    unlockFile,
    confirmFile,
    getAdCustNotDowload,
    getAdCustNotConfirmed,
    getAdProvNotDowload,
    getProvNotDowload,
    getCustNotDowload,
    getCustNotConfirmed,
    searchFile,
    getDownloadList,
    getFilePath,
    getConfirmList,
    getMakeDeliverableList,
    makeDeliverableExchange,
    makeDeliverableCustomer,
    getMe,
    putSftpCustomer,
    deleteSftpCustomer
}